import { productViewItemControls } from '../productViewItem.controls.js';
export const productViewImageListMapperRequest = ({
  productId,
  viewMode,
  blockProductPhotoHeight,
  photoWidth,
  photoHeight,
  isProductPhotoLazy,
  limitPhotoCount,
  colorInitialId,
  renderedPhotoId
}) => ({
  productId,
  productViewMode: viewMode,
  blockProductPhotoHeight,
  photoWidth,
  photoHeight,
  isProductPhotoLazy,
  limitPhotoCount: limitPhotoCount - 1,
  colorId: colorInitialId,
  RenderedPhotoId: renderedPhotoId
});

/* @ngInject */
function ProductViewImageListCtrl($element, $attrs, $parse, $scope, $http, $q, productViewService, $compile) {
  const ctrl = this;
  ctrl.$onInit = function () {
    ctrl.productId = $attrs.productId != null ? $parse($attrs.productId)($scope) : null;
    ctrl.viewMode = $attrs.viewMode != null ? $parse($attrs.viewMode)($scope) : null;
    ctrl.blockProductPhotoHeight = $attrs.blockProductPhotoHeight != null ? $parse($attrs.blockProductPhotoHeight)($scope) : null;
    ctrl.photoWidth = $attrs.photoWidth != null ? $parse($attrs.photoWidth)($scope) : null;
    ctrl.photoHeight = $attrs.photoHeight != null ? $parse($attrs.photoHeight)($scope) : null;
    ctrl.isProductPhotoLazy = $attrs.isProductPhotoLazy != null ? $parse($attrs.isProductPhotoLazy)($scope) : null;
    ctrl.limitPhotoCount = $attrs.limitPhotoCount != null ? $parse($attrs.limitPhotoCount)($scope) : 5;
    ctrl.colorInitialId = $parse($attrs.colorInitialId)($scope);
    ctrl.renderedPhotoId = $parse($attrs.renderedPhotoId)($scope);
    ctrl.isLoadedHtml = false;
    ctrl.photosStorage = null;
    ctrl.currentPhotos = [];
    ctrl.imageCtrls = [];
    ctrl.initial = true;
    ctrl.productViewItem.addControl(productViewItemControls.productListCtrl, ctrl);
    ctrl.currentColorId = ctrl.colorInitialId;
    productViewService.addCallback('setView', viewObj => {
      ctrl.viewMode = viewObj.viewName;
      ctrl.filterPhotos({
        isVisible: ctrl.isVisible,
        colorId: ctrl.currentColorId
      });
    });
  };
  ctrl.addImageCtrl = function (ctrlChild) {
    const tryId = ctrl.imageCtrls.indexOf(ctrlChild);
    if (tryId !== -1) return tryId;
    return ctrl.imageCtrls.push(ctrlChild);
  };
  ctrl.removeImageCtrl = function (id) {
    ctrl.imageCtrls.splice(id, 1);
  };
  ctrl.updatePhotos = function () {
    ctrl.imageCtrls.forEach((imageCtrl, i) => {
      if (ctrl.checkAvailablePhoto(i)) {
        imageCtrl.changeSrc(ctrl.currentPhotos[i], ctrl.viewMode);
      } else if (ctrl.currentPhotos.length > 0) {
        imageCtrl.hiddenImage();
      } else {
        imageCtrl.changeSrc(undefined, ctrl.viewMode);
      }
    });
  };
  ctrl.checkAvailablePhoto = function (index) {
    return index >= 0 && index < Math.min(ctrl.limitPhotoCount, ctrl.currentPhotos.length);
  };
  ctrl.getPhoto = function (photoIndex) {
    return ctrl.currentPhotos[photoIndex];
  };
  ctrl.getPhotos = function () {
    if (ctrl.photosStorage != null && ctrl.photosStorage.length) return $q.resolve(ctrl.photosStorage);
    if (ctrl.photosPromise) return ctrl.photosPromise;
    ctrl.photosPromise = productViewService.getPhotos(ctrl.productId).then(photos => {
      ctrl.photosStorage = photos;
      return photos;
    });
    return ctrl.photosPromise;
  };
  ctrl.filterPhotos = function ({
    isVisible,
    colorId,
    onlyColorPhoto
  }) {
    ctrl.isVisible = typeof isVisible === 'undefined' ? ctrl.isVisible : isVisible;
    ctrl.currentColorId = colorId;
    ctrl.lastOnlyColorPhoto = onlyColorPhoto;
    if (ctrl.isVisible === false) return;
    if (ctrl.photosStorage) {
      ctrl.currentPhotos = productViewService.filterPhotos(ctrl.photosStorage, colorId, onlyColorPhoto).slice(0, ctrl.limitPhotoCount);
    } else if (colorId != null && colorId !== ctrl.colorInitialId) {
      // фото грузятся лениво (hover/touch); без них при смене цвета осталось бы стартовое фото исходного цвета
      ctrl.getPhotos().then(() => {
        if (ctrl.photosStorage == null) return;
        ctrl.filterPhotos({
          colorId: ctrl.currentColorId,
          onlyColorPhoto: ctrl.lastOnlyColorPhoto
        });
      });
      return;
    }
    ctrl.updatePhotos();
  };
  productViewService.addCallback('setView', () => {
    requestAnimationFrame(() => {
      $element[0].scrollLeft = 0;
    });
  });
  ctrl.getPhotoHtml = function (data) {
    if (data.productId == null) return $q.resolve();
    return $http.post('/mobile/product/ProductViewPhoto', data).then(response => response.data);
  };
  ctrl.insertHtml = function () {
    if (ctrl.isLoadedHtml) return $q.resolve();
    const data = {
      productId: ctrl.productId,
      photoWidth: ctrl.photoWidth,
      photoHeight: ctrl.photoHeight,
      isProductPhotoLazy: ctrl.isProductPhotoLazy,
      limitPhotoCount: ctrl.limitPhotoCount,
      colorInitialId: ctrl.colorInitialId,
      renderedPhotoId: ctrl.renderedPhotoId
    };
    if (ctrl.productViewMode != null) {
      data.viewMode = ctrl.productViewMode.viewName;
      data.blockProductPhotoHeight = ctrl.productViewMode.getCurrentBlockPhotoHeight();
    } else {
      data.viewMode = ctrl.viewMode;
      data.blockProductPhotoHeight = ctrl.blockProductPhotoHeight;
    }
    data.blockProductPhotoHeight = parseInt(data.blockProductPhotoHeight, 10);
    return ctrl.getPhotoHtml(productViewImageListMapperRequest(data)).then(html => {
      if (html == null) return;
      ctrl.isLoadedHtml = true;
      $element.find('.js-skeleton-photos').remove();
      $element.append(html);
      $compile(Array.prototype.slice.call($element.children('.mobile-product-view-item-image-inner'), 1))($scope.$new());
    });
  };
}
ProductViewImageListCtrl.$inject = ["$element", "$attrs", "$parse", "$scope", "$http", "$q", "productViewService", "$compile"];
export default ProductViewImageListCtrl;